import {Box, Skeleton} from '@customink/pigment-react';
import React from 'react';
import useBreakpoint from '../../../../hooks/useBreakpoint';
import useRemToPX from '../../../../hooks/useRemToPX';
import sharedBoxStyles from './sharedStyles';

const Loader = () => {
  const breakpoint = useBreakpoint();
  const skeletonWidth = breakpoint === 'sm' ? useRemToPX(6) : '100%';

  return (
    <Box sx={sharedBoxStyles}>
      {Array.from({length: 4}).map((_, i) => (
        <Skeleton
          variant="rounded"
          height="18.5rem"
          width={skeletonWidth}
          key={`related-products-skeleton-${i + _}`}
        />
      ))}
    </Box>
  );
};

export default Loader;
